// extracted by mini-css-extract-plugin
module.exports = {"button":"_ad8412","shortLabel":"_ec9bb4","hideLabel":"_e09b22"};